﻿package com.mgacreative.hotelru.feature.ai_assistant.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.core.tenant.TenantSession
import com.mgacreative.hotelru.feature.ai_assistant.domain.ChatMessage
import com.mgacreative.hotelru.feature.ai_assistant.domain.HotelTools
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AiAssistantViewModel(
    tenantSession: TenantSession
) : ViewModel() {

    private val hotelTools = HotelTools(tenantSession)

    private val _messages = MutableStateFlow<List<ChatMessage>>(emptyList())
    val messages: StateFlow<List<ChatMessage>> = _messages.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    fun sendMessage(query: String) {
        if (query.isBlank()) return

        val userMsg = ChatMessage("m_${kotlin.random.Random.nextInt()}", "user", query)
        _messages.value = _messages.value + userMsg

        _isLoading.value = true

        viewModelScope.launch {
            // Simulated AI processing with Function Calling
            val lowerQuery = query.lowercase()
            
            // Simulating Anthropic analyzing the prompt and calling a specific tool
            val toolResponse = when {
                lowerQuery.contains("boş oda") || lowerQuery.contains("kaç oda") -> hotelTools.getAvailableRooms()
                lowerQuery.contains("gelir") || lowerQuery.contains("kazanç") -> hotelTools.getMonthlyRevenue()
                lowerQuery.contains("müşteri") || lowerQuery.contains("kalan") -> hotelTools.getTopGuests()
                lowerQuery.contains("temizlik") -> hotelTools.getPendingHousekeeping()
                else -> "Üzgünüm, sadece otel verileriniz (Odalar, Gelir, Misafirler, Temizlik) hakkında yetkilendirildim. Lütfen farklı bir soru sorun."
            }

            // Simulating Anthropic generating the final conversational response based on toolResponse
            val finalResponse = "Sistem veritabanını (Tenant İzolasyonlu Araçlarla) kontrol ettim:\n\n$toolResponse"

            val aiMsg = ChatMessage("m_${kotlin.random.Random.nextInt()}", "assistant", finalResponse)
            _messages.value = _messages.value + aiMsg
            _isLoading.value = false
        }
    }
}


